import React, { useCallback, useRef } from "react";
import { useTranslation } from "react-i18next";
import * as msal from "@azure/msal-browser";

type Props = {
	clientId: string;
	setError: (err: string) => void;
	attemptLogin: (token: string) => void;
};

export default ({ clientId, setError, attemptLogin }: Props) => {
	const { t } = useTranslation();

	const msalInstance = useRef(
		new msal.PublicClientApplication({
			auth: {
				clientId,
				authority: "https://login.microsoftonline.com/organizations",
			},
		})
	);

	const onLoginClick = useCallback(async () => {
		try {
			const loginResponse = await msalInstance.current.loginPopup();
			attemptLogin(loginResponse.idToken);
		} catch (error) {
			console.error(error);
		}
	}, [attemptLogin]);

	return (
		<button
			onClick={onLoginClick}
			className="azure-login-btn"
			aria-label={t("main.login.azureBtn")}>
			<img
				src="/images/ms-symbollockup_signin_light.svg"
				aria-hidden={true}
				alt={t("main.login.azureBtn")}
			/>
		</button>
	);
};
